import adminRoutes from './routes/admin-panel/adminRoutes';
import { BookingSuccess } from './routes/booking/components';
import {
  EventCreate,
  EventList,
  EventDashboard,
  SellTickets,
  UserListing,
  LandingPage,
  AllEvents,
  BuyerFlow,
  UserProfile,
  RequestEvent,
  TermsAndConditions,
  PrivacyPolicy,
  NotFound,
  EventPage,
  AddCategory,
  AttendeesForm,
  Checkout,
  CheckoutPc,
  Booking,
  Landing,
  MobileError,
  RefundPolicy
} from './routes/index';

export default [
  {
    id: 'create-event',
    path: '/event/create',
    documentTitle: 'Create Event',
    element: EventCreate,
    permission: 'email',
  },
  {
    id: 'edit-event',
    path: '/event/edit/:eventId',
    documentTitle: 'Edit Event',
    element: EventCreate,
    permission: 'email',
  },
  {
    id: 'event-list',
    path: '/events',
    documentTitle: 'Events List',
    element: EventList,
    permission: 'email',
  },
  {
    id: 'event-dashboard',
    path: '/event/dashboard/:eventId',
    documentTitle: 'Event Dashboard',
    element: EventDashboard,
    permission: 'email',
  },
  {
    id: 'event-page',
    path:'/event/:id',
    documentTitle:'Event Page',
    element: EventPage,
  },
  {
    id: 'add-category',
    path:'/event/add-category',
    documentTitle:'Add Category',
    element: AddCategory,
  },
  {
    id: 'attendees-details',
    path:'/event/attendees',
    documentTitle:'attendees-details',
    element: AttendeesForm,
  },
  {
    id: 'checkout',
    path:'/event/checkout',
    documentTitle:'checkout',
    element: window.innerWidth < 650 ? Checkout : CheckoutPc,
  },
  {
    id: 'booking-success',
    path:'/event/booking/success',
    documentTitle:'Booking Success',
    element: BookingSuccess,
  },
  ...adminRoutes,
  {
    id: 'landing-page',
    path: '/',
    documentTitle: 'Landing Page',
    element: LandingPage,
  },
  {
    id: 'all-events',
    path: '/all-events',
    documentTitle: 'All Events',
    element: AllEvents,
  },
  {
    id: 'buyer-flow',
    path: '/:id',
    documentTitle: 'Buyer Flow',
    element: BuyerFlow,
  },
  {
    id: 'sell-tickets',
    path: '/sell-tickets',
    documentTitle: 'Sell Tickets',
    element: SellTickets,
  },
  {
    id: 'user-lissting',
    path: '/my-listing',
    documentTitle: 'User Listing',
    permission: 'email',
    element: UserListing,
  },
  {
    id: 'user-profile',
    path: '/user-profile',
    documentTitle: 'User Profile',
    permission: 'email',
    element: UserProfile,
  },
  {
    id: 'Request-event',
    path: '/request',
    documentTitle: 'Request Event',
    element: RequestEvent,
  },
  {
    id: 'terms of service',
    path: '/terms-and-conditions',
    documentTitle: 'Terms and Conditions',
    element: TermsAndConditions,
  },
  {
    id: 'Privacy Policy',
    path: '/privacy-policy',
    documentTitle: 'Privacy Policy',
    element: PrivacyPolicy,
  },
  {
    id: 'Refund Policy',
    path: '/refund-policy',
    documentTitle: 'Refund Policy',
    element: RefundPolicy,
  },
  {
    id:'Not Found',
    path:'*',
    documentTitle: 'Not Found',
    element:NotFound,
  },
  {
    id: 'booking',
    path: '/bookings',
    documentTitle: 'Booking',
    permission: 'email',
    element: Booking,
  },
  {
    id:'landing',
    path:'/landing',
    documentTitle:'Landing',
    element: Landing,
  },
];